// extracted by mini-css-extract-plugin
export default {"body":"About_body__CFSPC","heading":"About_heading__3vRb2","content":"About_content__ZNwLd","box":"About_box__wQGB6","bottom":"About_bottom__CqDXf"};